import { styled, Stack } from '@mui/material'

export const MainContainer = styled(Stack)(({ theme }) => {
  return {
    padding: theme.spacing(2, 4),
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    backgroundColor: theme.palette.shades.shade04,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.shades.shade03}`,
  }
})

export const SettingsContent = styled(Stack)(({ theme }) => {
  return {
    flexDirection: 'column',
  }
})
